module.exports = new __parcel__URL__("Meeting notes.431ccf5e.svg").toString();